interface Props {
  [key: string]: {
    name: string;
    shortLangPrefix: string;
    i18nKey: string;
    urlLangPrefix: string;
  };
}

export const languages: Props = {
  en: {
    name: 'English',
    shortLangPrefix: 'en',
    i18nKey: 'en',
    urlLangPrefix: ''
  }
};

export default languages;
